<template>
  <CatalogCrudView
    title="Tipos de documento financeiro"
    subtitle="Defina a natureza das obrigações financeiras geradas pelo sistema."
    singular="tipo de documento"
    list-title="Tipos de documento cadastrados"
    icon="file"
    :service="service"
    :fields="fields"
    :columns="columns"
    :form-defaults="formDefaults"
  />
</template>

<script>
import CatalogCrudView from '../components/CatalogCrudView.vue'
import service from '../services/documentTypeService'

export default {
  name: 'DocumentTypesView',
  components: { CatalogCrudView },
  data: () => ({
    service,
    formDefaults: { name: '', code: '', direction: 'R', isRecurring: false, isActive: true },
    fields: [
      { key: 'name', label: 'Nome', required: true, maxlength: 100, placeholder: 'Ex.: Mensalidade', span: 4 },
      { key: 'code', label: 'Código', required: true, maxlength: 30, placeholder: 'Ex.: MSL', uppercase: true, span: 2 },
      { key: 'direction', label: 'Direção', required: true, type: 'select', disabled: true, span: 2, options: [{ value: 'R', label: 'A receber (R)' }] },
      { key: 'isRecurring', label: 'Recorrente', type: 'select', span: 2, options: [{ value: true, label: 'Sim' }, { value: false, label: 'Não' }] },
      { key: 'isActive', label: 'Situação', type: 'select', span: 2, options: [{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }] }
    ],
    columns: [
      { text: 'Id', value: 'id' }, { text: 'Nome', value: 'name', emphasis: true },
      { text: 'Código', value: 'code', type: 'code' }, { text: 'Direção', value: 'direction', type: 'direction' },
      { text: 'Recorrente', value: 'isRecurring', type: 'boolean' }, { text: 'Situação', value: 'isActive', type: 'status' },
      { text: 'Criado em', value: 'createdAt', type: 'date' }
    ]
  })
}
</script>
